import { useEffect, useState } from "react";
import { fetchFeatures, featuresToTable } from "./arcgis.js";

/* A live layer's rows, read once, for a screen that only wants to look
   something up in it.
 *
 * The Trackers screen reads a layer to draw it. This is the other case: the
 * Dashboards board needs the schools layer only to turn AAS into a name, so
 * it wants the rows and none of the machinery. A layer that cannot be read is
 * not an error worth stopping a page for. The board still draws, with codes
 * instead of names, and says why.
 */
export function useLayerRows(source, read = fetchFeatures) {
  const url = source?.url ?? "";
  const where = source?.where || "1=1";
  const [state, setState] = useState({ loading: Boolean(url), columns: [], rows: [], error: "" });

  useEffect(() => {
    if (!url) { setState({ loading: false, columns: [], rows: [], error: "" }); return undefined; }
    let live = true;
    setState((s) => ({ ...s, loading: true, error: "" }));
    read(url, where)
      .then((payload) => {
        if (!live) return;
        const { columns, rows } = featuresToTable(payload);
        setState({ loading: false, columns, rows, error: "" });
      })
      .catch((e) => { if (live) setState({ loading: false, columns: [], rows: [], error: e.message }); });
    return () => { live = false; };
  }, [url, where, read]);

  return state;
}
